export default __webpack_public_path__ + "static/media/predlog2020.5b903152.pdf";